import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { FaArrowRight } from "react-icons/fa6";
import Footer from "./Footer";
import ThoughtLeadershipForm from "./BroucherDiv";
import CustomBlogContainer from "./custom/CustomBlogContainer";
import CustomHeading from "./custom/CustomHeading";
import CustomContent from "./custom/CustomContent";
import thoughtImg from "../assets/thoughtImage.jpg";
import tabThoughtImg from "../assets/tabThoughtImg.jpg";
import mobileThoughtImg from "../assets/mobileThoughtImage.jpg";
import rightArrowImg from "../assets/rightarrow.png";
import leftArrowImg from "../assets/leftarrow.png";
import { Helmet } from "react-helmet";

const ThoughtLeadership = () => {
  const [viewModal, setViewModal] = useState(false);
  useEffect(()=>{
    window.scrollTo(0,10);
  },[])
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    centerMode: true,
    centerPadding: "0px",
    nextArrow: (
      <div>
        <img className="custom-arrow" src={rightArrowImg} alt="Next" />
      </div>
    ),
    prevArrow: (
      <div>
        <img className="custom-arrow" src={leftArrowImg} alt="Previous" />
      </div>
    ),
  };

  return (
    <div>
      <Helmet>
        <title>Thought Leadership at Mother's Pride - Pioneering Early Childhood Education</title>
        <meta name="description" content="Discover how Mother's Pride leads in early childhood education through innovative teaching methodologies, expert insights, and a commitment to nurturing young minds." />
        <meta name="keywords" content="preschool programs, age-wise curriculum,toddler learning programs, early education, structured preschool curriculum" />
      </Helmet>
      <div className="overflow-hidden">
        {/* first heading */}

        <div className="bg-[#E0FAFF] px-[4%] py-[4%] lg:pt-[1%] ">
          <CustomHeading
            text={"Thought"}
            textSize={window.innerWidth < 850 ? "50px" : "60px"}
            spanText={" Leadership"}
            spanTextColor="#D31C4F"
            secondFontStyle="font-Wonderbar font-extrabold"
            textColor={"#D31C4F"}
            showHeart={true}
            rotateHeart="rotate-12"
            heartPosition={"absolute"}
            textAlign={"center"}
            heartTop={"0px"}
            position={"absolute"}
            heartMarginLeft={window.innerWidth < 750 ? "0px" : "20px"}
            leading={"75px"}
          />
          <div className="flex mt-[30px] sm:mt-[50px] lg:mt-10 w-full lg:flex-row flex-col justify-between gap-[2rem] sm:gap-[4rem]">
            <img
              src={
                window.innerWidth < 450
                  ? window.innerWidth < 850
                    ? thoughtImg
                    : mobileThoughtImg
                  : tabThoughtImg
              }
              alt="thought-img"
              className="h-[260px] sm:w-full w-[380px] sm:h-[400px] lg:h-[450px] rounded-md sm:max-w-[621px] mx-auto sm:min-w-[620px]"
            />
            <div>
              <CustomContent
                textSize="18px"
                leading="26px"
                textColor="#111010"
                text={`The first five years shape a lifetime of learning, and at Mother’s Pride, we honor the trust you place in us. More than a preschool, we are a nurturing home beyond home, where love and learning go hand in hand. Our holistic approach, built on the <b>High Fives of Development</b>, ensures every child thrives. With a curriculum rooted in love and supported by state-of-the-art <b>Castles of Love</b>, we create an environment where every hug is a lesson, every smile an achievement, and every milestone a celebration.`}
                textAlign={window.innerWidth < 450 ? "left" : "justify"}
                tracking="tracking-tight"
                marginTop="16px"
              />
              <CustomContent
                marginTop="10px"
                textSize="18px"
                leading="26px"
                textColor="#111010"
                text={
                  "Guided by our <b>Honorary Chairperson, Mrs. Sudha Gupta</b>, we champion <b>positive parenting</b> through insightful seminars, empowering you to nurture your child with confidence. We provide a stimulating and joyful learning experience, where children are encouraged to explore, imagine, and express themselves freely. Our dedicated educators focus on fostering emotional intelligence, creativity, and social skills, ensuring a well-rounded development."
                }
                tracking="tracking-tight"
                textAlign={window.innerWidth < 450 ? "left" : "justify"}
              />
              <CustomContent
                marginTop="8px"
                textSize="18px"
                leading="26px"
                textColor="#111010"
                text={
                  "With a <b>perfect blend of academics, extracurricular activities, and life skills</b>, we prepare children for a bright future while preserving the innocence of childhood. Every day at Mother’s Pride is filled with new experiences, meaningful interactions, and boundless joy. Join us in shaping a generation that grows with love, learns with passion, and leads with confidence—because at Mother’s Pride, <b>childhood is a celebration!</b>"
                }
                tracking="tracking-tight"
                textAlign={window.innerWidth < 450 ? "left" : "justify"}
              />
            </div>
          </div>
          <CustomContent
            width={"90%"}
            textSize="25px" // Just the value, not the full "text-[25px]" class
            marginTop="55px"
            textColor="#D31C4F"
            text="Join us in shaping a generation that grows with love, learns with passion, and leads with confidence—because at Mother’s Pride, childhood is a celebration!"
            textAlign={window.innerWidth < 450 ? "left" : "justify"}
            fontWeight={600}
            fontStyle="italic"
          />
        </div>
        <ThoughtLeadershipForm />
        <CustomBlogContainer type={"News"} paddingX={"4%"} />
        <Footer marginX={"4%"} />
      </div>
    </div>
  );
};

export default ThoughtLeadership;
